import { SyntheticEvent, useCallback } from 'react';

import { AutocompleteChangeDetails } from '@material-ui/lab';

import { FormFieldProps, useFormField } from '@spotify/confidence-core-react';
import {
  IdentityAutocompleteProps,
  OwnerAutocomplete,
  useDefaultOwner,
} from '@spotify/plugin-confidence-iam-react';

export type IdentityFormFieldProps = FormFieldProps<string | null> &
  Omit<IdentityAutocompleteProps, 'value'>;

export const OwnerFormField = ({
  field = 'owner',
  initialValue,
  onChange,
  loading,
  ...props
}: IdentityFormFieldProps) => {
  const [defaultOwner, , { loading: loadingUserIdentity }] = useDefaultOwner();
  const { value, setValue } = useFormField<string | null>(
    field,
    initialValue !== undefined ? initialValue : defaultOwner || undefined,
  );

  const handleChange = useCallback(
    (
      event: SyntheticEvent<EventTarget>,
      newIdentity: string | null,
      reason: string,
      details?: AutocompleteChangeDetails<string>,
    ) => {
      setValue(newIdentity);
      onChange?.(event, newIdentity, reason, details);
    },
    [onChange, setValue],
  );

  return (
    <OwnerAutocomplete
      value={value}
      onChange={handleChange}
      label="Owner"
      required
      data-testid="owner"
      loading={loadingUserIdentity || loading}
      {...props}
    />
  );
};
